import { CardComponentProps } from "@~/types/types";
import { CloseOutlined as Close24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";
import { IconButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/IconButton";
import { REMOVE_PRODUCT } from "@~/utils/events";

export function RemoveButton({
  product,
}: Pick<CardComponentProps, "product" | "configProps">) {
  const { title } = product;
  const clickHandler = () => {
    window.dispatchEvent(
      new CustomEvent(REMOVE_PRODUCT, {
        detail: { productId: product.aliases.pimProductId },
      }),
    );
  };

  return (
    <IconButton
      IconComponent={Close24PxOutlinedIcon}
      aria-label={`Remove ${title}`}
      data-component="RemoveButton"
      onClick={clickHandler}
      data-testid="remove-button"
      variant="clear-dark"
    ></IconButton>
  );
}
